(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_groups/banner-carousel/assets/javascripts/carousel-common.js') >= 0) return;  svs.modules.push('/components/banner_groups/banner-carousel/assets/javascripts/carousel-common.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const renderCarousel = async (model, widgetInfo, position, req, res) => {
  var _model$images;
  let bannerHelpers;
  if (svs.isServer) {
    const trinidad = require('@svenskaspelab/trinidad-core').core;
    bannerHelpers = trinidad.components.require('banner_common', 'banner-helpers');
  } else {
    bannerHelpers = svs.banner_common.banner_helpers;
  }
  const _ref = bannerHelpers.images || bannerHelpers,
    formatImages = _ref.formatImages;
  const _bannerHelpers = bannerHelpers,
    getRCTools = _bannerHelpers.getRCTools;
  const id = model.id,
    layoutConfig = model.layoutConfig,
    layoutType = model.layoutType,
    targetOffer = model.targetOffer,
    variant = model.variant;
  const tracking = {
    widget: widgetInfo,
    position
  };
  const _getRCTools = getRCTools({
      layoutType: layoutType.replace(/-/gi, '_'),
      model,
      res,
      req,
      tracking
    }),
    contentType = _getRCTools.contentType,
    features = _getRCTools.features,
    getCallToActions = _getRCTools.getCallToActions,
    hbsCompiled = _getRCTools.hbsCompiled,
    isThemeClassDefault = _getRCTools.isThemeClassDefault,
    themeClass = _getRCTools.themeClass,
    trackingString = _getRCTools.trackingString;
  const body = layoutConfig.body,
    header = layoutConfig.header;
  const images = ((_model$images = model.images) === null || _model$images === void 0 ? void 0 : _model$images.length) && (await formatImages(model, 'typeName', req));
  const actionViewConfig = {
    inverted: isThemeClassDefault
  };
  const callToActions = getCallToActions(actionViewConfig);

  const imagesByVariant = variant => {
    switch (variant) {
      case 'LANDSCAPE':
        return images.bannerImage_ASPECTRATIO_4_3 || images.bannerImage_BACKGROUND;
      case 'WIDESCREEN':
        return images.bannerImage_ASPECTRATIO_16_9 || images.bannerImage_DEFAULT;
      default:
        return images["bannerImage_".concat(variant)];
    }
  };
  const context = _objectSpread(_objectSpread({}, layoutConfig), {}, {
    aspect: variant.toLowerCase(),
    body,
    callToActions,
    contentType,
    features,
    header,
    id,
    images: imagesByVariant(variant),
    targetOffer,
    themeClass,
    trackingString,
    position
  });
  return hbsCompiled(context);
};
if (svs.isServer) {
  module.exports = {
    renderCarousel
  };
} else {
  svs.banner_common.banner_helpers.renderCarousel = renderCarousel;
}

 })(window);